import React, { useState } from 'react'
 
 
import DirectFarmerInvoiceList from './DirectFarmerInvoiceList';
import DirectFarmerInvoiceForm from './DirectFarmerInvoiceForm';

const DirectFarmerInvoice= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <DirectFarmerInvoiceForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
        ) : (
          <DirectFarmerInvoiceList addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
        )}  
    </>
  )
}

export default DirectFarmerInvoice